<!-- Spinner while product lines are being loaded -->
<div *ngIf="loading && !loadError" class="pd-loader">
    <hc-progress-spinner color="purple" [diameter]="75"></hc-progress-spinner>
</div>

<!-- Error loading content -->
<div *ngIf="!loading && loadError" class="pd-permission-error">
    <hc-icon fontSet="fa" fontIcon="fa-warning"></hc-icon>
    There was an error loading the product line list. Click below try again.
    <button hc-button size="lg" (click)="loadProductLines()">Reload Product Lines</button>
</div>

<div class="admin-product-lines-table-container" [hidden]="loadError || loading">
    <h2> <hc-icon fontSet="fa" fontIcon="fa-sitemap"></hc-icon> Product Lines </h2>
    <div class="admin-product-lines-table-action-bar">
        <button hc-button (click)="openAddEditModal(addEditProductLineModal, false)">Add Product Line</button>
        <hc-search-bar #searchbar placeholder="Search product lines" (triggerSearch)="applyFilter($event)"
            class="admin-product-lines-search"></hc-search-bar>
    </div>
    <table hc-table [borders]="false" class="admin-product-lines-table" [dataSource]="dataSource" hcSort>
        <!-- ID Column -->
        <ng-container hcColumnDef="id">
            <th hc-index-cell *hcHeaderCellDef hc-sort-header id="idHeader">ID</th>
            <td hc-index-cell *hcCellDef="let element">{{ element.productLineID }}</td>
        </ng-container>

        <!-- Name Column -->
        <ng-container hcColumnDef="name">
            <th hc-header-cell *hcHeaderCellDef hc-sort-header id="nameHeader">Name</th>
            <td hc-cell *hcCellDef="let element">{{ element.name }}</td>
        </ng-container>

        <!-- Icon Column -->
        <ng-container hcColumnDef="icon">
            <th hc-header-cell *hcHeaderCellDef hc-sort-header id="iconHeader">Icon</th>
            <td hc-cell *hcCellDef="let element">{{ icons[element.icon] }}</td>
        </ng-container>

        <!-- Icon Actions Column -->
        <ng-container hcColumnDef="actions" justify="center">
            <th hc-header-cell *hcHeaderCellDef id="actionsHeader"></th>
            <td hc-cell *hcCellDef="let element">
                <div class="hc-table-actions">
                    <span hcMenuIcon class="fa fa-trash hc-action-ico" hcTooltip="Remove product line"
                        (click)="removeProductLine(element)"></span>
                    <span hcMenuIcon class="fa fa-pencil hc-action-ico" hcTooltip="Edit product line"
                        (click)="openAddEditModal(addEditProductLineModal, true, element)"></span>
                </div>
            </td>
        </ng-container>

        <tr hc-header-row *hcHeaderRowDef="adminProductLinesDisplayedColumns"></tr>
        <tr hc-row *hcRowDef="let row; columns: adminProductLinesDisplayedColumns"></tr>
    </table>

    <div class="hc-empty-table-block" *ngIf="dataSource.filteredData.length === 0">
        <span class="hc-empty-table-block-ico hc-empty-ico"></span>
        <span class="hc-empty-table-block-msg">No product lines meet your search criteria.</span>
    </div>

    <hc-pagination [length]="adminProductLinesListLength" [pageSize]="adminProductLinesPageSize"
        [hidden]="loadError || loading"></hc-pagination>
</div>

<ng-template #addEditProductLineModal let-dismiss="dismiss" let-data="data">
    <hc-modal>
        <hc-modal-header>{{ data.edit ? 'Edit' : 'Add' }} Product Line</hc-modal-header>
        <hc-modal-body>
            <form [formGroup]="adminProductLineControl" class="admin-product line-form">
                <hc-form-field>
                    <hc-label>Name:</hc-label>
                    <input hcInput formControlName="name" placeholder="Enter name" class="name-input"
                        [required]="true" />
                    <hc-error>A name is required</hc-error>
                </hc-form-field>
                <hc-form-field>
                    <hc-label>Icon:</hc-label>
                    <hc-select formControlName="icon" placeholder="Select icon"
                        [placeholderValue]="null" [required]="true">
                        <option *ngFor="let icon of icons; let i = index" [ngValue]="i">{{ icon }}
                        </option>
                    </hc-select>
                    <hc-error>A icon is required</hc-error>
                </hc-form-field>
                <div class="icon-preview" *ngIf="adminProductLineControl.controls.icon.value !== null">
                    <img [src]="'../../../assets/product-line-icons/' + icons[adminProductLineControl.controls.icon.value!]"/>
                    <em>Icon Preview</em>
                </div>
            </form>
        </hc-modal-body>
        <hc-modal-footer>
            <button hc-button buttonStyle="link" (click)="dismiss()">Cancel</button>
            <button hc-button buttonStyle="primary"
                [disabled]="data.edit ? !adminProductLineControl.dirty : !adminProductLineControl.valid"
                (click)="data.edit ? editProductLine() : addProductLine()">
                {{ data.edit ? 'Update' : 'Add' }}
            </button>
        </hc-modal-footer>
    </hc-modal>
</ng-template>